import { render, staticRenderFns } from "./ConstructionDetails.vue?vue&type=template&id=52238364&scoped=true"
import script from "./ConstructionDetails.vue?vue&type=script&lang=js"
export * from "./ConstructionDetails.vue?vue&type=script&lang=js"
import style0 from "./ConstructionDetails.vue?vue&type=style&index=0&id=52238364&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52238364",
  null
  
)

export default component.exports